<template>
  <div class="doge-shell">
    <header class="doge-top green">
      <button class="doge-back" @click="$router.back()">‹</button>
      <h1 class="doge-title green-text">兑换记录</h1>
      <div class="doge-placeholder"></div>
    </header>
    <main class="doge-page-pad">
      <div v-for="item in records" :key="item.id" class="exchange-record">
        <div class="doge-row">
          <span>{{ item.created_at || '--' }}</span>
          <b :class="statusClass(item.status)">{{ statusText(item.status) }}</b>
        </div>
        <div class="doge-divider"></div>
        <div class="doge-row">
          <span>USDT兑换DOGE</span>
          <b>-{{ money(item.usdt_amount) }} USDT</b>
        </div>
        <div class="doge-row sub">
          <span>预计到账</span>
          <b class="doge-status-green">{{ doge(item.doge_amount) }} DOGE</b>
        </div>
        <div class="doge-row sub">
          <span>手续费</span>
          <b>{{ money(item.fee_amount) }} USDT</b>
        </div>
        <div class="hash-row" v-if="item.address">地址：{{ formatHash(item.address) }}</div>
        <div class="hash-row" v-if="item.tx_hash">Hash：{{ formatHash(item.tx_hash) }}</div>
      </div>
      <div v-if="loading" class="doge-empty">加载中...</div>
      <div v-else-if="!records.length" class="doge-empty">暂无兑换记录</div>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import BottomNav from '../../components/layout/BottomNav.vue';
export default {
  name: 'exchangeRecords',
  components: { BottomNav },
  data() { return { records: [], loading: false }; },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      try {
        await this.$store.dispatch('ensureDogeAuth');
        const r = await this.$axios.get('/api/doge/withdraws');
        const d = r.data && r.data.data;
        this.records = (d && d.data) || (Array.isArray(d) ? d : []);
      } catch (e) {
        this.records = [];
      } finally {
        this.loading = false;
      }
    },
    statusText(status) { return { 1: '待出金', 2: '链上确认中', 3: '成功', 4: '失败' }[Number(status)] || '处理中'; },
    statusClass(status) { return Number(status) === 3 ? 'doge-status-green' : Number(status) === 4 ? 'doge-status-red' : 'doge-status-orange'; },
    formatHash(v) { return v && v.length > 18 ? v.slice(0, 10) + '...' + v.slice(-8) : v; },
    money(v) { return Number(v || 0).toFixed(2); },
    doge(v) { return Number(v || 0).toFixed(8); }
  }
};
</script>
<style scoped>
.green-text{color:var(--doge-primary)!important}.exchange-record{background:#fff;border-radius:16px;padding:15px;margin-bottom:14px;box-shadow:0 6px 18px rgba(75,52,0,.07)}.exchange-record span{color:#8b806d}.exchange-record b{color:#211507}.exchange-record .sub{margin-top:8px;font-size:13px}.exchange-record .sub span{color:#8b806d}.hash-row{margin-top:10px;color:#8b806d;font-size:12px;word-break:break-all}.doge-status-red{color:#ff6b6b!important}.doge-status-orange{color:var(--doge-primary)!important}
</style>
